import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { PaginationState, PaginationValue } from "./pagination-state";
import { getAllComputationApprovalPaginationValueInitialState, getAllConflictProposalForApprovalValueInitialState, getAllProposalOfUserValueInitialState, getAllProposalPaginationValueInitialState, getBookedProposalPaginationValueInitialState, getComputationApprovalPaginationValueInitialState } from "./pagination-inital-state";

export type PaginationType = 
    | "bookedProposal" 
    | "allProposal" 
    | "approvalProposal" 
    | "allApprovalProposal"
    | "conflictProposalForApproval"
    | 'allProposalOfUser'

const initialState: PaginationState = {
    bookedProposalPagination: getBookedProposalPaginationValueInitialState(),
    allProposalPagination: getAllProposalPaginationValueInitialState(),
    approvalProposalPagination: getComputationApprovalPaginationValueInitialState(),
    allApprovalProposalPagination: getAllComputationApprovalPaginationValueInitialState(),
    conflictProposalForApprovalPagination: getAllConflictProposalForApprovalValueInitialState(),
    allProposalOfUserPagination: getAllProposalOfUserValueInitialState(),
};

const paginationKeyMap = {
    bookedProposal: "bookedProposalPagination",
    allProposal: "allProposalPagination",
    approvalProposal: "approvalProposalPagination",
    allApprovalProposal: "allApprovalProposalPagination",
    conflictProposalForApproval: "conflictProposalForApprovalPagination",
    allProposalOfUser: "allProposalOfUserPagination",
} as const;

const paginationSlice = createSlice({
    name: 'paginationSlice',
    initialState,
    reducers: {
        clearPagination: () => initialState,

        setPagination: (state, action: PayloadAction<{type: PaginationType; value: Partial<PaginationValue>}>) => {
            const { type, value } = action.payload;
            const paginationKey = paginationKeyMap[type];
            state[paginationKey] = { ...state[paginationKey], ...value };
        },

        resetPagination: (state, action: PayloadAction<PaginationType>) => {
            switch (action.payload) {
                case "bookedProposal":
                    state.bookedProposalPagination = getBookedProposalPaginationValueInitialState();
                    break;
                case "allProposal":
                    state.allProposalPagination = getAllProposalPaginationValueInitialState();
                    break;
                case "approvalProposal":
                    state.approvalProposalPagination = getComputationApprovalPaginationValueInitialState();
                    break;
                case "allApprovalProposal":
                    state.allApprovalProposalPagination = getAllComputationApprovalPaginationValueInitialState();
                    break;
                case "conflictProposalForApproval":
                    state.conflictProposalForApprovalPagination = getAllConflictProposalForApprovalValueInitialState();
                    break;
                case "allProposalOfUser":
                    state.allProposalOfUserPagination = getAllProposalOfUserValueInitialState();
                    break;
            }
        },
    },
});

export const {
    clearPagination,

    setPagination,
    resetPagination,
} = paginationSlice.actions;

export default paginationSlice.reducer;

export const selectBookedProposalPagination = (state: RootState) => state.paginationSlice.bookedProposalPagination;
export const selectAllProposalPagination = (state: RootState) => state.paginationSlice.allProposalPagination;
export const selectApprovalPagination = (state: RootState) => state.paginationSlice.approvalProposalPagination;
export const selectAllApprovalPagination = (state: RootState) => state.paginationSlice.allApprovalProposalPagination;
export const selectAllConflictProposalPagination = (state: RootState) => state.paginationSlice.conflictProposalForApprovalPagination;
export const selectAllProposalOfUserPagination = (state: RootState) => state.paginationSlice.allProposalOfUserPagination;